import React, { Fragment, Suspense, useEffect, useState } from 'react';
import { message } from 'antd';
import { BrowserRouter, Switch, Route, Link, Redirect, Router } from 'react-router-dom';
import OverlayLoaderComponent from './components/loader/overlay-loader.component';
import { navigationPages } from './constants/navigation/main-navigation';
import history from './history';
import GA from './helpers/GoogleAnalytics';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AuthService from 'services/auth-service';

const SystemPage = React.lazy(() => import("./pages/system.page"));
const AuthPage = React.lazy(() => import("./pages/auth.page"));

const Home = () => <Redirect to={navigationPages.System.Initial.url} />;

function App() {
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    AuthService.HandleRedirectCallback((err) => {
      message.error(err);
    }).then(loggedIn => {
      if (loggedIn) {
        history.push('/');
      }
    }).finally(() => {
      setAuthLoading(false);
    });
  }, []);

  if (authLoading) {
    return <OverlayLoaderComponent isVisible={true} />;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LeN_ukgAAAAAHVmDDYwKOnIP8ZOLmAsJipqlK4L"
    >
      <Router history={history} basename=''>
        {GA.init() && <GA.RouteTracker />}
        <Switch>
          <Suspense fallback={<OverlayLoaderComponent isVisible={true} />}>
            <Route exact path={`${process.env.PUBLIC_URL}/`} component={Home} />
            <Route path={`${process.env.PUBLIC_URL}${navigationPages.System.Root.url}`} component={SystemPage} />
            <Route path={`${process.env.PUBLIC_URL}${navigationPages.Login.Root.url}`} component={AuthPage} />
          </Suspense>
        </Switch>
      </Router>
    </GoogleReCaptchaProvider>
  );
}

export default App;
